import React from 'react';
import Translate from 'react-translate-component';
import { path } from 'ramda';
import * as yup from 'yup';

import { SALARY_SCAN, SALARY_NUMBER_SCAN } from 'constants/regexp';

export const required = value => !value ? <Translate content='errors.required' /> : undefined;

export const requiredIf = check => (value, values) => check(values) && required(value);

export const salaryNumberScan = (value) => {
    return value && !SALARY_NUMBER_SCAN.test(value) ? 'invalidSalaryValue' : undefined;
};
export const salaryScan = (value) => {
    return value && !SALARY_SCAN.test(value) ? 'invalidSalaryValue' : undefined;
};

export const lessThanSalaryTo = (value, model) => {
    const to = path(['salary', 'amount', 'to'], model);
    return to && (Number(value) > Number(to)) ? <Translate content='errors.mustBeLessThan' with={{value: to}} /> : undefined;
};

export const moreThanSalaryFrom = (value, model) => {
    const from = path(['salary', 'amount', 'from'], model);
    return from && (Number(value) < Number(from)) ? <Translate content='errors.mustBeMoreThan' with={{value: from}} /> : undefined;
};

export const maxLength = (maxLength) => (value) => {
    try {
        yup.string().maxLength(maxLength).validateSync(value);

        return undefined;
    } catch (error) {
        return error.message
    }
};

export const composeValidators = (...validators) => (value, allValues) => {
    const validator = validators.reduce((error, validator) => {
        if (error) {
            return error;
        } else {
            const asyncError = validator(value, allValues);

            return asyncError;
        }
    }, undefined);

    return validator;
};
